import { afterNextRender, ChangeDetectionStrategy, Component, signal } from '@angular/core';

/** how long the loader stays before it lifts away, counted from the page starting to load */
const SHOW_MS = 1000;
/** how long the lifting-away takes (the same figure is in preloader.scss) */
const LEAVE_MS = 600;

/**
 * The loader shown for about a second when the page opens: the back-to-top
 * button's recliner in its ring — the ring fills, the chair wakes and sits
 * up — and the company name rising letter by letter. Then it lifts away,
 * bottom to top, like the page's own way back up.
 *
 * It is in the server-rendered page, so it covers the first paint; the clock
 * runs from the start of the page load (performance.now), so a slow start
 * is not made slower by it.
 */
@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.html',
  styleUrl: './preloader.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.is-leaving]': 'leaving()', '[hidden]': 'gone()' },
})
export class Preloader {
  protected readonly name = 'Little Nap'.split('');
  protected readonly leaving = signal(false);
  protected readonly gone = signal(false);

  constructor() {
    afterNextRender(() => {
      setTimeout(() => this.leaving.set(true), Math.max(0, SHOW_MS - performance.now()));
      setTimeout(() => this.gone.set(true), Math.max(0, SHOW_MS - performance.now()) + LEAVE_MS);
    });
  }
}
